import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-confeccion-consumo',
    templateUrl: './confeccion.component.html'
})
export class ConfeccionConsumoComponent {


    @Input() confeccion;
    @Input() mix;

    constructor(
        private readonly _translate: TranslateService
    ) {}

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public get numCajasConfeccionPallet() {
      return this.confeccion.cajasConfeccion.reduce((acc,obj) => { return acc + obj.numCajas}, 0);
    }

}
